import { Outlet } from 'react-router-dom';

// 全局布局组件 — 超简洁，贺卡页面全屏沉浸式
export default function Layout() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-white">
      <main>
        <Outlet />
      </main>
      <footer className="py-6 text-center text-xs text-gray-400">
        <p>© {new Date().getFullYear()} 贺卡生成器 — 记录每一份温暖</p>
      </footer>
    </div>
  );
}
